// extracted by mini-css-extract-plugin
export default {"card":"Style_card__DHV6l"};